import React from 'react';
import useStyles from './Styles';
//import loading from './loading.svg';
import CircularProgress from '@mui/material/CircularProgress';


interface Props {
	isLoading:boolean,
}

const Loading:React.FC<Props> = (props)=> {
	const classes = useStyles();
	if(!props.isLoading){
		return (null);
	}
	return (
		<div id="loading" className={classes.loading}>
			<CircularProgress className={classes.spinner}/>
		</div>
    );
}

export default Loading;
